import {
    APPLICATION_SCOPE_TYPE,
    ITCIApplication,
    ITCIApplicationAuth,
    ITCIApplicationExecHistoryProvider,
    ITCIApplicationMonitoringProvider,
    ITCIExecHistoryResponse,
    ITCITenantComponentOptions,
    ITCIUserInfo,
    TCI_APP_DETAIL_MENU_TYPE,
    TCI_COMPONENT_MODE,
    TCITenantAppType,
    TCITenantSelectorType,
} from "@tci/common";

import {
    ITCIAppExecHistoryListInput, ITCIAppExecHistoryListOutput,
    TCITenantComponentInput, TCITenantComponentOutput
} from "../../../ng-tenant/tci-tenant-components";
import {Observable} from "rxjs";
import {NgUserService} from "../../../ng-shared/ng-services/ng-user.service";

export class BaseAppExecHistoryListComponentInput extends TCITenantComponentInput implements ITCIAppExecHistoryListInput {
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public application: ITCIApplication,
        public userService: NgUserService,
        public execHistoryListData: ITCIExecHistoryResponse,
        public execHistoryProvider: ITCIApplicationExecHistoryProvider,
        public monitoringProvider: ITCIApplicationMonitoringProvider,
        public mode: TCI_COMPONENT_MODE | string,
        public componentOption?: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>
    ) {
        super();
    }

    getApplication(): ITCIApplication {
        return this.application;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }
}

export class BaseAppExecHistoryListComponentOutput<E extends ITCIAppExecHistoryListOutput> extends TCITenantComponentOutput<E> {
    constructor() {
        super();
    }
}
